"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prosemirror_state_1 = require("prosemirror-state");
var utils_1 = require("./utils");
var card_1 = require("./card");
var prosemirror_view_1 = require("prosemirror-view");
var basic_view_1 = require("./basic-view");
var decoration_1 = require("../decoration");
var prose_util_1 = require("../../libs/prose-util");
var behavior_1 = require("../keymap/behavior");
exports.BSControlKey = new prosemirror_state_1.PluginKey('basicControl');
exports.BasicCtrlPlugin = function (config) {
    var editable = true;
    return new prosemirror_state_1.Plugin({
        key: exports.BSControlKey,
        state: {
            init: function () {
                return {
                    listNestedLevel: 0
                };
            },
            apply: function (tr, set) {
                var data = tr.getMeta(exports.BSControlKey);
                if (!data)
                    return set;
                if (data.listNestedLevel !== undefined) {
                    set.listNestedLevel = data.listNestedLevel;
                }
                if (data.editable !== undefined) {
                    editable = data.editable;
                }
                return set;
            }
        },
        props: {
            handleDOMEvents: {
                paste: function (view) {
                    var state = view.state, dispatch = view.dispatch;
                    var $from = state.selection.$from;
                    if ($from.depth &&
                        state.selection instanceof prosemirror_state_1.TextSelection &&
                        !$from.parent.content.size &&
                        prose_util_1.isOriginAttrs($from.parent)) {
                        dispatch(view.state.tr.setSelection(prosemirror_state_1.NodeSelection.create(state.doc, $from.before())));
                    }
                    return false;
                }
            },
            editable: function () { return editable; },
            decorations: function (state) {
                if (!config.placeholder)
                    return;
                var doc = state.doc;
                var decoState = decoration_1.DecoKey.getState(state);
                if (decoState === prosemirror_view_1.DecorationSet.empty && prose_util_1.isEmptyDoc(state.doc)) {
                    return prosemirror_view_1.DecorationSet.create(doc, [prosemirror_view_1.Decoration.widget(1, utils_1.createPlaceHolder(config.placeholder))]);
                }
            },
            handleClickOn: function (view, pos, node, nodePos, event) {
                if (!editable)
                    return false;
                return utils_1.chainClickEvent({ node: node, view: view, pos: pos, nodePos: nodePos, event: event }, card_1.cardSingleClick);
            },
            handleDoubleClick: function (view, pos) {
                utils_1.insertPWhenBlock(view, pos);
                return false;
            },
            handleKeyDown: function (view, event) {
                if (!editable)
                    return false;
                return utils_1.chainKeyDownEvent(view, event, utils_1.passZeroWidthChar, card_1.cardInput);
            }
        },
        view: function (view) { return new basic_view_1.BasicView(view, config); },
        appendTransaction: function (trs, oldState, newState) {
            var tr = newState.tr;
            var isModify = false;
            if (!oldState.storedMarks && newState.storedMarks && oldState.doc.nodeSize !== newState.doc.nodeSize) {
                newState.storedMarks.forEach(function (mark) {
                    // 拥有notStore标记的mark不保存
                    if (mark.type.spec.notStore) {
                        tr.removeStoredMark(mark);
                        isModify = true;
                    }
                });
            }
            var $from = newState.selection.$from;
            if ($from.depth) {
                var isRemoved = prose_util_1.removeExcludesMarks(tr);
                if (isRemoved && !isModify)
                    isModify = true;
                prose_util_1.resetUnInheritAttr(oldState, newState);
            }
            var isMerged = behavior_1.checkAndMergeList(tr, tr.selection.$from.after(1));
            if (isMerged && !isModify)
                isModify = true;
            return isModify ? tr : undefined;
        }
    });
};
//# sourceMappingURL=index.js.map